import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { apiConstants } from "../shared/api.constants";
import { of, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  apiEndpoint: any;
  apiConstants: any;

  constructor(private http: HttpClient) {
    this.apiConstants = apiConstants;
    this.apiEndpoint = environment.API_ENDPOINT;
  }

  getData(url, obj, load) {
    let params = new HttpParams();
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== "" && obj[key] !== undefined && obj[key] !== null) {
        params = params.set(key, obj[key]);
      }
    });
    return this.http.get<any>(this.apiEndpoint + url, {
      params,
      reportProgress: load,
    });
  }

  postImage(url, obj, load) {
    const formData = new FormData();
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== "" && obj[key] !== undefined && obj[key] !== null) {
        if (typeof obj[key] === "object" && obj[key].length) {
          formData.append(key, JSON.stringify(obj[key]));
        } else formData.append(key, obj[key]);
      }
    });
    return this.http.post<any>(this.apiEndpoint + url, formData, {
      reportProgress: load,
    });
  }

  postData(url, obj, load) {
    const formData = new FormData();
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== "" && obj[key] !== undefined && obj[key] !== null) {
        if (typeof obj[key] === "object" && obj[key].length) {
          formData.append(key, JSON.stringify(obj[key]));
        } else if (typeof obj[key] === "object" && !obj[key].length) {
          // --------- any state meeting the condition comes here
        } else formData.append(key, obj[key]);
      }
    });
    return this.http.post<any>(this.apiEndpoint + url, formData, {
      reportProgress: load,
    });
  }

  putData(url, obj, load) {
    const formData = new FormData();
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== "" && obj[key] !== undefined) {
        formData.append(key, obj[key]);
      }
    });
    return this.http.put<any>(this.apiEndpoint + url, formData, {
      reportProgress: load,
    });
  }

  post(url, data) {
    url = environment.API_ENDPOINT + url;
    let headers;
    if (localStorage.getItem("token")) {
      headers = {
        authorization: localStorage.getItem("token"),
      };
    }
    return this.http.post(url, data, { headers });
  }

  private mapDataToUrl(data: any) {
    if (data.body) {
      const obj = {
        ...data.body,
      };

      const params = [];
      Object.keys(obj).forEach((key) => {
        params.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
        );
      });
      return params.join("&");
    } else {
      return "";
    }
  }

  public get(data) {
    let url = "";
    url = environment.API_ENDPOINT + data.url;
    const params = this.mapDataToUrl(data);
    url += "?" + params;
    return this.http
      .get(url, { params: data.params })
      .pipe(map(this.apiResponse));
  }

  apiResponse(res: any) {
    return res;
  }
}
